// Module
var code = "<div class=\"w-full my-12 md:my-16\"> <figure> <div view=\"Iframely\" data=\"[[ data ]]\"></div> <figcaption class=\"my-6 text-grey_3 text-[13px] leading-6\">[[ caption ]]</figcaption> </figure> </div> ";
// Exports
export default code;